// extracted by mini-css-extract-plugin
export default {"header":"styles_header__WJ8eT","dataSection":"styles_dataSection__OpYUp","chipText":"styles_chipText__xLkLj"};